import { AiOutlineHome } from "react-icons/ai";
import { RiProgress6Line } from "react-icons/ri";
import { AiFillHome } from "react-icons/ai";
import { RiProgress6Fill } from "react-icons/ri";
import { RiFileCheckFill } from "react-icons/ri";
import { RiFileCheckLine } from "react-icons/ri";

import { BsFileEarmarkArrowUp } from "react-icons/bs";
import { BsFileEarmarkArrowUpFill } from "react-icons/bs";

export const SidebarLinks = [
  {
    title: "Почетна",
    icon: <AiOutlineHome />,
    selectedIcon: <AiFillHome />,
    path: "/",
  },
  {
    title: "Ново барање",
    icon: <BsFileEarmarkArrowUp />,
    selectedIcon: <BsFileEarmarkArrowUpFill />,
    path: "/entries/new",
  },
  {
    title: "Барања",
    icon: <RiProgress6Line />,
    selectedIcon: <RiProgress6Fill />,
    path: "/entries/submitted",
  },
  {
    title: "Завршени барања",
    icon: <RiFileCheckLine />,
    selectedIcon: <RiFileCheckFill />,
    path: "/entries/completed",
  },
];
